// A/B framing for the FirstTimeHero — chooses between "$ pot first"
// and "60-second promise" once per visitor and persists the choice so
// the experience stays stable across reloads.
//
// Variant assignment is uniformly random at first read. The `?hv=`
// query param ("pot" | "promise") forces a variant for QA / sharing.
import { trackFunnel } from "@/lib/funnelTracker";

export type HeroVariant = "pot" | "promise";
const STORAGE_KEY = "hl.heroVariant.v1";

export function getOrAssignHeroVariant(): HeroVariant {
  if (typeof window === "undefined") return "pot";
  try {
    const url = new URL(window.location.href);
    const forced = url.searchParams.get("hv");
    if (forced === "pot" || forced === "promise") {
      localStorage.setItem(STORAGE_KEY, forced);
      return forced;
    }
    const existing = localStorage.getItem(STORAGE_KEY);
    if (existing === "pot" || existing === "promise") return existing;
    const next: HeroVariant = Math.random() < 0.5 ? "pot" : "promise";
    localStorage.setItem(STORAGE_KEY, next);
    return next;
  } catch {
    return "pot";
  }
}

export function trackHeroVariantView(variant: HeroVariant) {
  trackFunnel("hero_variant_event", { event: "view", variant });
}

export function trackHeroVariantClick(variant: HeroVariant) {
  trackFunnel("hero_variant_event", { event: "click", variant });
}
